import React from 'react';
import Select from 'react-select';

const selectStyle = {
  control: (defaultStyles) => ({
    ...defaultStyles,
    borderRadius: '1rem',
    borderColor: '#ccc',
    cursor: 'pointer',
    fontSize: '16px',
    padding: '0.25rem',
    width: '100%'
  }),
  indicatorSeparator: (defaultStyles) => ({
    ...defaultStyles,
    display: 'none'
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    fontSize: '16px'
  }),
  menu: (defaultStyles) => ({
    ...defaultStyles,
    color: '#0e2d47',
    fontSize: '16px',
  }),
  menuList: (defaultStyles) => ({
    ...defaultStyles,
    color: '#0e2d47',
    fontSize: '16px',
  }),
  multiValue: (defaultStyles) => ({
    ...defaultStyles,
    color: '#0e2d47',
    fontSize: '16px',
    display: 'flex',
    flexDirecton: 'row'
  }),
  multiValueLabel: (defaultStyles) => ({
    ...defaultStyles,
    fontSize: '16px',
  }),
  singleValue: (defaultStyles) => ({
    ...defaultStyles,
    color: '#0e2d47',
    fontSize: '16px'
  })
}

const StyledSelect = ({
  name,
  options,
  placeholder,
  styles
}) => (
  <Select
    name={ name }
    options={ options }
    placeholder={ placeholder }
    styles={ styles }
  />
);

export {
  StyledSelect,
  selectStyle
}



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/Activities/SearchFilters/Select.jsx